<div class="cf-dlg">
  <div class="cf-dlg-header">
    <div class="cf-dlg-icon">
      <mat-icon>account_balance</mat-icon>
    </div>
    <div class="cr-header-text">
      <h2 class="cf-dlg-title">{{ title }}</h2>
      <p class="cf-dlg-subtitle" *ngIf="subtitle">{{ subtitle }}</p>
    </div>
    <button mat-icon-button class="cf-dlg-close" (click)="close()" [disabled]="saving" aria-label="Cerrar">
      <mat-icon>close</mat-icon>
    </button>
  </div>

  <app-loading-state *ngIf="!ready" message="Cargando constituciones…"></app-loading-state>
  <app-loading-state *ngIf="ready && saving" [message]="savingMessage"></app-loading-state>

  <ng-container *ngIf="ready && !saving && loadError">
    <div class="cf-dlg-body">
      <div class="cr-empty cr-empty--error">
        <mat-icon>error</mat-icon>
        <span>No se pudieron cargar las constituciones del crédito.</span>
      </div>
    </div>
    <div class="cf-dlg-footer">
      <button mat-stroked-button class="cf-dlg-btn-secondary" (click)="close()">Cerrar</button>
      <button mat-flat-button class="cf-dlg-btn-primary" (click)="retry()">
        <mat-icon>refresh</mat-icon> Reintentar
      </button>
    </div>
  </ng-container>

  <ng-container *ngIf="ready && !saving && !loadError">
    <div class="cf-dlg-body cr-body">

      <div class="cr-summary">
        <div class="cr-summary__left">
          <div class="cr-summary__icon"><mat-icon>account_balance_wallet</mat-icon></div>
          <div>
            <span class="cr-summary__label">Importe inicial del crédito</span>
            <span class="cr-summary__amount">{{ (data.credit.importeInicial || 0) | number:'1.2-2' }} €</span>
            <span class="cr-summary__hint">
              Constituido {{ total | number:'1.2-2' }} €<ng-container *ngIf="yearHint"> · {{ yearHint }}</ng-container>
            </span>
          </div>
        </div>
      </div>

      <div class="cr-section">
        <span class="cf-dlg-section__label">
          {{ editing ? 'Editar constitución' : 'Nueva constitución' }}
          <button *ngIf="editing" type="button" class="cr-link" (click)="cancelEdit()">Cancelar edición</button>
        </span>

        <div class="cr-grid">
          <div *ngIf="isEmployee" class="cf-field--required" [class.cf-field--invalid]="submitted && missingPlazo">
            <app-autocomplete [control]="control('plazo')" [config]="{ label: 'Corto / largo plazo', placeholder: 'Seleccionar plazo…', options: termOptions, required: true, strict: true }">
            </app-autocomplete>
            <div class="cf-field__error" *ngIf="submitted && missingPlazo"><mat-icon>error</mat-icon> Selecciona el plazo</div>
          </div>

          <div class="cf-field--required" [class.cf-field--invalid]="submitted && missingDate">
            <app-date [control]="control('fecha')" [config]="{ label: 'Fecha', required: true }"></app-date>
            <div class="cf-field__error" *ngIf="submitted && missingDate"><mat-icon>error</mat-icon> Indica la fecha</div>
          </div>

          <div class="cf-field--required" [class.cf-field--invalid]="submitted && missingConcept">
            <app-field [control]="control('concepto')" [config]="{ label: 'Concepto', type: 'text', required: true, maxLength: 100 }"></app-field>
            <div class="cf-field__error" *ngIf="submitted && missingConcept"><mat-icon>error</mat-icon> Indica el concepto</div>
          </div>

          <div class="cf-field--required" [class.cf-field--invalid]="submitted && invalidAmount">
            <app-field [control]="control('importe')" [config]="{ label: 'Importe', type: 'number', required: true, inputmode: 'decimal', step: 0.01, suffix: '€' }"></app-field>
            <div class="cf-field__error" *ngIf="submitted && invalidAmount"><mat-icon>error</mat-icon> {{ isEmployee ? 'Indica el importe' : 'Debe ser mayor que cero' }}</div>
          </div>

          <div>
            <app-field [control]="control('comisionApertura')" [config]="{ label: 'Comisión de apertura', type: 'number', inputmode: 'decimal', step: 0.01, suffix: '€' }"></app-field>
          </div>

          <div>
            <app-field [control]="control('gastosBancarios')" [config]="{ label: 'Gastos bancarios', type: 'number', inputmode: 'decimal', step: 0.01, suffix: '€' }"></app-field>
          </div>

          <div class="cf-field--required" [class.cf-field--invalid]="submitted && missingActivity">
            <app-autocomplete [control]="control('activity')" [config]="{ label: 'Actividad', placeholder: 'Seleccionar actividad…', options: activities, required: true, autoSelectSingle: true, strict: true }">
            </app-autocomplete>
            <div class="cf-field__error" *ngIf="submitted && missingActivity"><mat-icon>error</mat-icon> Selecciona la actividad</div>
          </div>

          <div class="cf-field--required" [class.cf-field--invalid]="submitted && missingBankAccount">
            <app-autocomplete [control]="control('bankAccount')" [config]="{ label: 'Cuenta bancaria', placeholder: 'Seleccionar cuenta…', options: bankAccounts, required: true, autoSelectSingle: true, strict: true }">
            </app-autocomplete>
            <div class="cf-field__error" *ngIf="submitted && missingBankAccount"><mat-icon>error</mat-icon> Selecciona la cuenta bancaria</div>
          </div>

          <div *ngIf="showProjects">
            <app-autocomplete [control]="control('project')" [config]="{ label: 'Proyecto', placeholder: 'Sin proyecto', options: projects, strict: true }">
            </app-autocomplete>
          </div>

          <div *ngIf="showExpenseProjectTypes">
            <app-autocomplete [control]="control('expenseProjectType')" [config]="{ label: 'Tipo de gasto del proyecto', placeholder: 'Sin tipo', options: expenseProjectTypes, strict: true }">
            </app-autocomplete>
          </div>
        </div>
      </div>

      <div class="cr-section">
        <span class="cf-dlg-section__label">
          Constituciones registradas
          <span class="cr-section__hint" *ngIf="yearHint">{{ yearHint }}</span>
        </span>

        <div class="cr-empty" *ngIf="!items.length">
          <mat-icon>info</mat-icon>
          <span>Todavía no hay constituciones registradas{{ yearHint ? ' en este ejercicio' : '' }}.</span>
        </div>

        <div class="cr-rows" *ngIf="items.length">
          <div class="cr-row" *ngFor="let item of items; trackBy: trackByUid" [class.cr-row--editing]="editing?.uid === item.uid">
            <div class="cr-row__main">
              <div class="cr-row__amount">{{ (item.importe || 0) | number:'1.2-2' }} €</div>
              <div class="cr-row__meta" [title]="itemMeta(item)">{{ itemMeta(item) }}</div>
            </div>
            <div class="cr-row__date">{{ itemDate(item) }}</div>
            <div class="cr-row__actions">
              <button mat-icon-button class="cr-row__btn" (click)="startEdit(item)" title="Editar" aria-label="Editar constitución">
                <mat-icon>edit</mat-icon>
              </button>
              <button mat-icon-button class="cr-row__btn cr-row__btn--danger" (click)="remove(item)" title="Eliminar" aria-label="Eliminar constitución">
                <mat-icon>delete</mat-icon>
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="cf-dlg-footer">
      <button mat-stroked-button class="cf-dlg-btn-secondary" (click)="close()">Cerrar</button>
      <button mat-flat-button class="cf-dlg-btn-primary" (click)="save()" [disabled]="saving">
        <mat-icon>{{ editing ? 'save' : 'check_circle' }}</mat-icon> {{ editing ? 'Guardar cambios' : 'Registrar constitución' }}
      </button>
    </div>
  </ng-container>
</div>
